import { useState, useEffect } from 'react';

function cleanUpContainer(containerId: string) {
    const myNode = document.getElementById(containerId);
    if (myNode) {
        myNode.innerHTML = '';
    }
}

export const useDojoWallet = (
    clientSessionSecret: string | undefined,
    containerId: string,
    onPaymentComplete: (response: Dojo.PaymentResponse) => void,
    onPaymentInitiated: () => void,
    onPaymentCancelled: () => void
) => {
    const [wallet, setWallet] = useState<Dojo.WalletPayment | null>(null);

    useEffect(() => {
        if (wallet || !clientSessionSecret) {
            return;
        }
        cleanUpContainer(containerId);
        const config = {
            containerId,
            paymentDetails: {
                paymentToken: clientSessionSecret
            },
            buttonConfig: {
                color: 'black',
                type: 'plain'
            },
            emailRequired: true,
            billingAddressRequired: false,
            shippingAddressRequired: false,
            callbacks: {
                onPaymentInitiated,
                onPaymentCancelled
            }
        };

        const dojoWallet = new Dojo.WalletPayment(config, undefined, onPaymentComplete);

        setWallet(dojoWallet);
    }, [clientSessionSecret, containerId, onPaymentComplete, onPaymentInitiated, onPaymentCancelled, wallet]);

    return { wallet };
};
